import { render, staticRenderFns } from "./addInfo.vue?vue&type=template&id=f18ca264&"
import script from "./addInfo.vue?vue&type=script&lang=js&"
export * from "./addInfo.vue?vue&type=script&lang=js&"
import style0 from "./addInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports